import { Button } from "primereact/button";
import { getFrameAtPos, getNextFrame, parseCameraDirections, parseVideoFrameXML, controlCameraMove, getNextFrameForVideoPlay } from "../panoramaFeatures/panoramaFunctions/panoramaFunctions";
import { panoramaApiSlice } from "../../../api/rtk/base/slices/panoramaApiSlice";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import PanoramaInfoWidget from "../panoramaAddons/panoramaInfoWidget/PanoramaInfoWidget";
import { useEffect, useState } from "react";
import { SmallFrameWidget } from "./SmallFrameWidget";
import ToastMessageContainer from "../../toastMessageContainer/ToastMessageContainer";
const backwardFastIconSrc = require('../../../assets/images/fontAwesomeIcons/backward-fast-solid.svg').default
const backwardStepIconSrc = require('../../../assets/images/fontAwesomeIcons/backward-step-solid.svg').default
const backwardMoveIconSrc = require('../../../assets/images/fontAwesomeIcons/backward-solid.svg').default
const forwardStepIconSrc = require('../../../assets/images/fontAwesomeIcons/forward-step-solid.svg').default
const forwardFastIconSrc = require('../../../assets/images/fontAwesomeIcons/forward-fast-solid.svg').default
const forwardMoveIconSrc = require('../../../assets/images/fontAwesomeIcons/forward-solid.svg').default

export default function VideoFramesWidget() {

    const [fetchNextFrameQuery] = panoramaApiSlice.useLazyFetchNextFrameQuery();
    const [fetchFastNextFrameQuery] = panoramaApiSlice.useLazyFetchFastNextFrameQuery();
    const { hasNextFrame, hasPreviousFrame, cameraDirectionsArray, xml, panoramaCurrentPositionID, panoramaVideoIsPlaying, videoCurrentDirection, cameraImageIsRendering: cameraImageIsLoading } = useAppSelector(state => state.panorama)
    const [formattedCameraDirections, setFormattedCameraDirections] = useState<any>([])

    useEffect(() => {
        if (cameraDirectionsArray?.cameraDirection?.length > 0 && panoramaCurrentPositionID) {
            setFormattedCameraDirections(parseCameraDirections(cameraDirectionsArray, panoramaCurrentPositionID))
        }
    }, [cameraDirectionsArray, panoramaCurrentPositionID])

    useEffect(() => {
        try {
            let xmlTemp = xml
            if (xmlTemp) {
                parseVideoFrameXML(xmlTemp)
                if (panoramaVideoIsPlaying && !cameraImageIsLoading) {
                    getNextFrameForVideoPlay('cam', videoCurrentDirection, fetchNextFrameQuery)
                }
            }
        } catch (error: any) {
            console.error("Ошибка:", error.message);
        }
    }, [xml, panoramaVideoIsPlaying, videoCurrentDirection, cameraImageIsLoading])

    const cameraMoveBackwardButtonActive = panoramaVideoIsPlaying && videoCurrentDirection === 'back'
    const cameraMoveForwardButtonActive = panoramaVideoIsPlaying && videoCurrentDirection === 'next'

    return (
        <div className="camera-view">
            <ToastMessageContainer windowType="panorama"/>
            <div className="camera-control-buttons video-control-buttons">
                <div className="camera-control-buttons">
                    <Button disabled={!hasPreviousFrame} rounded className={cameraMoveBackwardButtonActive ? 'camera-move-active' : ''} onClick={() => controlCameraMove('back', panoramaVideoIsPlaying)}><img alt="backwardStepIcon" src={backwardMoveIconSrc} height={19} width={22} /></Button>
                    <Button disabled={!hasPreviousFrame} rounded onClick={() => getFrameAtPos('back', fetchFastNextFrameQuery)}><img alt="backwardFastIcon" src={backwardFastIconSrc} height={19} width={22} /></Button>
                    <Button disabled={!hasPreviousFrame} rounded onClick={() => getNextFrame('back', fetchNextFrameQuery)}><img alt="backwardStepIcon" src={backwardStepIconSrc} height={19} width={22} /></Button>
                    <Button disabled={!hasNextFrame} rounded onClick={() => getNextFrame('next', fetchNextFrameQuery)}><img alt="forwardStepIcon" src={forwardStepIconSrc} height={19} width={22} /></Button>
                    <Button disabled={!hasNextFrame} rounded onClick={() => getFrameAtPos('next', fetchFastNextFrameQuery)}><img alt="forwardFastIcon" src={forwardFastIconSrc} height={19} width={22} /></Button>
                    <Button disabled={!hasNextFrame} rounded className={cameraMoveForwardButtonActive ? 'camera-move-active' : ''} onClick={() => controlCameraMove('next', panoramaVideoIsPlaying)}><img alt="forwardStepIcon" src={forwardMoveIconSrc} height={19} width={22} /></Button>
                </div>
            </div>
            <div className="camera-image-grid-mix">
                {formattedCameraDirections && formattedCameraDirections.map((camera: any, index: any) => {
                    return <SmallFrameWidget key={camera.name + index} amount={formattedCameraDirections.length} url={camera.url} name={camera.name} />
                })}
            </div>
            <PanoramaInfoWidget />
        </div>
    )
}
